import { atom } from 'jotai';
import {
  PrivateAppLoginStatusResponse,
  PrivateUser as ApiPrivateUser,
} from '@idk-web/api';
import { store } from '@/state/store';

export type PrivateUser = {
  name: string;
  email: string;
  credits: number;
  termsOfServiceAccepted: boolean;
  hasValidatedEmail: boolean;
};

export type PrivateAuthState =
  | {
      status: 'LOGGED_OUT';
      user: null;
      token: null;
    }
  | {
      status: 'LOGGED_IN';
      user: PrivateUser;
      token: string;
    };

const initialState: PrivateAuthState = {
  status: 'LOGGED_OUT',
  user: null,
  token: null,
};

export const privateAuthState = atom<PrivateAuthState>(initialState);

export const privateLoginStatus = atom((get) => get(privateAuthState).status);

export const privateUser = atom((get) => get(privateAuthState).user);

export function setPrivateAuthState(state: PrivateAuthState): void {
  store.set(privateAuthState, state);
}

export function logout(): void {
  setPrivateAuthState(initialState);
}

export function login(
  payload: Extract<PrivateAppLoginStatusResponse, { status: 'COMPLETED' }>,
): void {
  setPrivateAuthState({
    status: 'LOGGED_IN',
    user: {
      name: payload.user.name,
      email: payload.user.email ?? '',
      credits: payload.user.credits,
      termsOfServiceAccepted: payload.user.termsOfServiceAccepted,
      hasValidatedEmail: payload.user.hasValidatedEmail,
    },
    token: payload.token,
  });
}

export function updateUser(user: ApiPrivateUser): void {
  const state = store.get(privateAuthState);

  if (state.status === 'LOGGED_OUT') {
    return;
  }

  setPrivateAuthState({
    ...state,
    user: {
      name: user.name,
      email: user.email ?? '',
      credits: user.checksLeft,
      termsOfServiceAccepted: user.termsOfServiceAccepted,
      hasValidatedEmail: user.hasValidatedEmail,
    },
  });
}

export default privateAuthState;
